<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0 max-w-full">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <!-- Header Section -->
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4 max-w-sm">
              <p class="text-sm">
                Reporte de venta perdida que muestra las diferencias entre cantidades deseadas,
                vendidas, confirmadas, entregadas y facturadas. Incluye análisis comercial,
                logístico y real con soporte para UMB y UMP.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Reporte de Venta Perdida
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Análisis detallado de pérdidas en el proceso de venta por material y socio de negocio
        </div>
      </div>

      <!-- Actions Section -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div
          class="mt-6 flex flex-col sm:flex-row shrink-0 sm:items-center space-y-3 sm:space-y-0 sm:space-x-3 sm:ml-4 sm:mt-0">

          <button *ngIf="hasData()" mat-flat-button color="primary" (click)="onExport()" matTooltip="Exportar a Excel">
            <mat-icon class="icon-size-5" svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Content Section with Tabs -->
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent w-full">
      <!-- Tab Navigation -->
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)"
        class="flex-shrink-0">
        <!-- Commercial Tab -->
        <mat-tab label="Venta Perdida Comercial">
        </mat-tab>

        <!-- Summary Tab -->
        <mat-tab label="Resumen">
        </mat-tab>
      </mat-tab-group>

      <!-- Router Outlet for Tab Content -->
      <div class="flex-auto overflow-hidden">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Filter Sidebar -->
  <app-filter [isOpened]="filterOpened" (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
      <app-filter-section title="Rango de fechas" [expanded]="true">
        <app-dates-filters [form]="filterForm" [showDateCreationRange]="true"> </app-dates-filters>
      </app-filter-section>

      <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
        <app-configuration-filters [form]="filterForm" [company]="true" [salesOffice]="true" [warehouse]="true" [loadData]="loadConfigData">
        </app-configuration-filters>
      </app-filter-section>

      <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
        <app-routes-filters [form]="filterForm" [route]="true" [loadData]="loadRoutesData"> </app-routes-filters>
      </app-filter-section>

      <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
        <app-business-partners-filters [form]="filterForm" [businessPartner]="true" [assignedUser]="true"
        [loadData]="loadBusinessPartnersData">
        </app-business-partners-filters>
      </app-filter-section>

      <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
        <app-materials-management-filters [form]="filterForm" [material]="true" [materialGroup]="true"
        [loadData]="loadMaterialsData">
        </app-materials-management-filters>
      </app-filter-section>

      <!-- FS-37: Campos de Usuario de la Cadena de Distribución del soldTo -->
      <app-filter-section title="Campos de Usuario" [expanded]="false" [formGroup]="filterForm">
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Grupo de Vendedor</mat-label>
          <input matInput formControlName="salesGroup" placeholder="Código del grupo de vendedor">
        </mat-form-field>

        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Zona de Venta</mat-label>
          <input matInput formControlName="salesZone" placeholder="Código de la zona de venta">
        </mat-form-field>
      </app-filter-section>
  </app-filter>
</mat-sidenav-container>